import { createSelector } from '@reduxjs/toolkit';
import { REFERRING_CLINIC_SLICE_NAME } from 'store/slices/slicesNames';
import { BCBS_NORTH_CAROLINA } from 'utils/constants';
import * as selectClient from '../config/selectClient';
import { getReferringClinicConfig } from './referringClinicConfig';

export const referringClinic = (state) => state[REFERRING_CLINIC_SLICE_NAME].referringClinic;

export const referringClinicOptions = createSelector(
  [selectClient.name],
  (client) => getReferringClinicConfig(client).options || []
);

export const referringClinicOptionsGroupBy = createSelector(
  [selectClient.name],
  (client) => getReferringClinicConfig(client).groupBy
);

export const includeNoneOption = createSelector(
  [selectClient.name],
  (client) => getReferringClinicConfig(client).includeNoneOption ?? false
);

export const sortedReferringClinicOptions = createSelector(
  [referringClinicOptions, referringClinicOptionsGroupBy, includeNoneOption],
  (options, groupBy, includeNone) => {
    const noneOption = {
      name: 'None',
    };

    const sortedOptions = [...options].sort((a, b) => a.name.localeCompare(b.name));

    if (groupBy) {
      sortedOptions.sort((a, b) => a[groupBy].localeCompare(b[groupBy]));
    }

    if (includeNone) sortedOptions.unshift(noneOption);

    return sortedOptions;
  }
);

export const requireReferringClinic = createSelector(
  [selectClient.name],
  (client) => client === BCBS_NORTH_CAROLINA
);

export const showReferringClinicSelect = createSelector(
  [requireReferringClinic, referringClinicOptions],
  (referringClinicIsRequired, clinicOptions) =>
    referringClinicIsRequired && clinicOptions?.length > 0
);
